export default {
  getLineItemsByAppId: (state, getters, rootState, rootGetters) => (appId) => {
    const mediation = rootGetters['monetization/currentMediation']
    return state.lineItems[mediation][appId]
  }
}
